export const QR_CODE_TYPES = {
  DEFAULT: "Default (link to landing page)",
  WECHAT: "WeChat (with partner code encoded)",
};
